module.exports = __webpack_public_path__ + "media/images/big-blog-thumb-d2bb24195a3fefdac67f3d18f5e0540b.jpg";